import { render, staticRenderFns } from "./otherOperationsActivity.vue?vue&type=template&id=21a7b31e"
import script from "./otherOperationsActivity.vue?vue&type=script&lang=js"
export * from "./otherOperationsActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports